import React from 'react'

import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Col, Row, Divider } from '_zari/core'

import * as RolCrud from 'services/rol.service'

import { ValidationSchema } from './validation'

import * as FormGroups from './formGroups'
import * as Modals from './modals'
import * as Sections from './sections'

import { CodigosTransaccionesConstant, CodigosPermisos } from 'constants/index'

const NuevoMainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)
  const [transaccionModal, setTransaccionModal] = React.useState(false)

  const history = useHistory()

  const formInitialValues = React.useMemo(
    () => ({
      nombre: editarData.nombre ?? '',
      solicitaViaticos: editarData.solicitaViaticos ?? false,
      permisos: editarData.permisos ?? [],
      transacciones: editarData.transacciones ?? []
    }),
    [editarData]
  )

  const submitHandler = React.useCallback(
    async data => {
      if (editarData._id) {
        await RolCrud.actualizarxId(editarData._id, data)
          .then(() => {
            history.push(`/${CodigosTransaccionesConstant.ROLES_LISTA}`)
            __zariContext.snack('success', 'El registro se ha actualizado.')
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      } else {
        await RolCrud.nuevo(data)
          .then(() => {
            history.push(`/${CodigosTransaccionesConstant.ROLES_LISTA}`)
            __zariContext.snack('success', 'El registro se ha agregado.')
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      }
    },
    [__zariContext, history, editarData]
  )

  return (
    <>
      <Row>
        <Col md={12}>
          <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
            {({ errors, handleSubmit, isSubmitting, touched, setFieldValue, values }) => (
              <>
                <Form>
                  <Row>
                    <Col md={6}>
                      <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
                      <FormGroups.SolicitarViaticosFormGroup iError={errors.solicitaViaticos} iTouched={touched.solicitaViaticos} fIsSubmitting={isSubmitting} />
                    </Col>
                  </Row>
                  <Divider title='Permisos' />
                  <Row className='mb-3'>
                    <Col md={10}></Col>
                    <Col md={2} className='text-right'>
                      <Button onClick={() => setFieldValue('transacciones', CodigosTransaccionesConstant.__array)}>
                        Agregar todas las transacciones
                      </Button>
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col md={10} />
                    <Col md={2} className='text-right'>
                      <Button onClick={() => setTransaccionModal(true)}>Agregar transaccion</Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={10} />
                    <Col md={2} className='text-right'>
                      <Button
                        color='danger'
                        onClick={() => {
                          setFieldValue('transacciones', [])
                          setFieldValue('permisos', [])
                        }}
                      >
                        Eliminar todas las transacciones
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    {values.transacciones.map(x => (
                      <Col md={4} key={x}>
                        <Sections.CardTransaccionSection
                          transaccion={x}
                          transacciones={values.transacciones}
                          permisosxTransaccion={CodigosPermisos.__array.filter(y => y.startsWith(x))}
                          setFieldValue={setFieldValue}
                          permisosSeleccionados={values.permisos}
                        />
                      </Col>
                    ))}
                  </Row>
                  <Row className='mt-4'>
                    <Col md={12} className='text-right'>
                      <Button onClick={handleSubmit}>Guardar</Button>
                    </Col>
                  </Row>
                </Form>
                {transaccionModal && (
                  <Modals.TransaccionModal
                    show={transaccionModal}
                    handleClose={() => setTransaccionModal(false)}
                    value={values.transacciones}
                    setFieldValue={setFieldValue}
                  />
                )}
              </>
            )}
          </Formik>
        </Col>
      </Row>
    </>
  )
}

export default NuevoMainForm
